import { z } from "zod";

export enum ChatAction {
  SUGGEST_QUERIES = "suggest-queries",
  DISPLAY_OPTIONS = "display-options",
  APPLY_FILTERS = "apply-filter",
}

export const chatActionSchema = z.nativeEnum(ChatAction);

export const suggestQueryDataSchema = z.object({
  query: z.string(),
});

export type SuggestQueryData = z.infer<typeof suggestQueryDataSchema>;

export const chatOptionSchema = z.object({
  label: z.string(),
  action: chatActionSchema,
  data: z.union([suggestQueryDataSchema, z.object({})]),
});

export type ChatOption = z.infer<typeof chatOptionSchema>;

export const chatOptionsSchema = z.object({
  options: z.array(chatOptionSchema),
});

export type ChatOptions = z.infer<typeof chatOptionsSchema>;

export const chatContextSchema = z.object({
  page: z.string(),
  context: z.object({
    action: chatActionSchema,
    data: z.union([suggestQueryDataSchema, chatOptionsSchema]),
  }),
});

export type ChatContext = z.infer<typeof chatContextSchema>;
